import BaseApi from './base';

class Temperature extends BaseApi {
    endpoint = 'temperatures';

    getReview(params) {
        return this.getAxios().get(`/review`, {params});
    }
}

export default new Temperature();




// WEBPACK FOOTER //
// ./src/psuite-js/apis/temperatures/temperature.js